import GuidanceRegistry from '../guidance-registry.js';

GuidanceRegistry.register({
    type: "action-item-ewf-guided-setup-copays",
    prompt: (guidanceItem) => getPrompt(guidanceItem.workflowType),
    briefDescription: 'Copays',
    openAction: {
        text: "Where to add/update copays?",
        url: (guidanceItem) => `/employer/${guidanceItem.employerId}/general`,
        row: "Copays"
    },
    completeAction: {
    },
});

function getPrompt(workflowType){
   return 'Highly Recommended:  Click Add copay and enter all plan copays your employees may be charged by any of their medical providers. This helps ensure funds are used for eligible expenses.';
}



// WEBPACK FOOTER //
// ./src/guidance/items/guidance-copays.js